import { FormActions } from "../../components/common/FormActions";
import {
  API_MERCHANT_BUSINESS_CONFIGURABLES,
  API_MERCHANT_INDUSTRIES_CONFIGURABLES,
} from "../../utils/apis";
import {
  createColumn,
  createViewEdit,
  formatDate,
  getForm,
  getRegister,
  stringifyName,
} from "../../utils/helpers";
import {
  URL_MERCHANT_BUSINESS_CONFIGURABLES,
  URL_MERCHANT_INDUSTRIES_CONFIGURABLES,
} from "../../utils/urls";

export const useMerhantConfigurablesindustry = () => {
  const tableColumns = () => [
    {
      id: "name",
      header: "Name",
      filter: true,
    },

    ...["created_at", "actions"].map((item) => createColumn(item)),
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      const row = {
        ...item,
        created_at: formatDate(item.created_at),
        actions: (
          <FormActions
            actions={createViewEdit(
              URL_MERCHANT_INDUSTRIES_CONFIGURABLES,
              item?.id,
            )}
          />
        ),
      };
      return row;
    }),
  ];

  const viewData = (item: any) => {
    return {
      name: item?.name,
      key: item?.key,
      created_at: formatDate(item?.created_at),
      created_by: stringifyName({ ...item?.created_by }),
    };
  };

  const formRoute = getForm(URL_MERCHANT_INDUSTRIES_CONFIGURABLES);

  return { tableColumns, tableData, viewData, formRoute };
};

export const useMerhantConfigurablesindustryForm = () => {
  const sections = [
    {
      title: "Configurable Details",
      fields: [
        {
          field_name: "name",
          type: "text",
          label: "Configurable Name",
          props: { required: true },
        },
      ],
    },
  ];

  const redirect = getRegister(URL_MERCHANT_INDUSTRIES_CONFIGURABLES);
  const title = "Industry";

  return { sections, redirect, title };
};

export const useMerhantConfigurablesBusiness = () => {
  const tableColumns = () => [
    {
      id: "name",
      header: "Name",
      filter: true,
    },

    ...["created_at", "actions"].map((item) => createColumn(item)),
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      const row = {
        ...item,
        created_at: formatDate(item.created_at),
        actions: (
          <FormActions
            actions={createViewEdit(
              URL_MERCHANT_BUSINESS_CONFIGURABLES,
              item?.id,
            )}
          />
        ),
      };
      return row;
    }),
  ];

  const viewData = (item: any) => {
    return {
      name: item?.name,
      key: item?.key,
      created_at: formatDate(item?.created_at),
      created_by: stringifyName({ ...item?.created_by }),
    };
  };

  const formRoute = getForm(URL_MERCHANT_BUSINESS_CONFIGURABLES);

  return { tableColumns, tableData, viewData, formRoute };
};

export const useMerhantConfigurablesBusinessForm = () => {
  const sections = [
    {
      title: "Configurable Details",
      fields: [
        {
          field_name: "name",
          type: "text",
          label: "Configurable Name",
          props: { required: true },
        },
      ],
    },
  ];

  const redirect = getRegister(URL_MERCHANT_BUSINESS_CONFIGURABLES);
  const title = "Business Classification";

  return { sections, redirect, title };
};

export const submitMerchantIndustriesConfigurables = (
  payload: any,
  id: string,
) => {
  if (id) {
    return {
      id,
      api: API_MERCHANT_INDUSTRIES_CONFIGURABLES,
      params: {
        ...payload,
      },
    };
  }
  return {
    api: API_MERCHANT_INDUSTRIES_CONFIGURABLES,
    params: {
      ...payload,
    },
  };
  return {};
};

export const submitMerchantBusinessConfigurables = (
  payload: any,
  id: string,
) => {
  if (id) {
    return {
      id,
      api: API_MERCHANT_BUSINESS_CONFIGURABLES,
      params: {
        ...payload,
      },
    };
  }
  return {
    api: API_MERCHANT_BUSINESS_CONFIGURABLES,
    params: {
      ...payload,
    },
  };
  return {};
};
